import { IntlShape, useIntl } from 'react-intl';
import { ZendeskUnreadState } from '../../../integrations/zendeskMessaging';
import { Badge, LiveRegion } from './styles';

interface ChatUnreadBadgeProps {
  unread: ZendeskUnreadState;
}

export const getVisibleChatUnreadCount = (
  unread: ZendeskUnreadState
): number | null =>
  unread.status === 'known' && unread.count > 0 ? unread.count : null;

export const formatChatControlLabel = (
  intl: IntlShape,
  unread: ZendeskUnreadState,
  baseLabel?: string
): string => {
  const count = getVisibleChatUnreadCount(unread);
  if (baseLabel) {
    return count === null
      ? baseLabel
      : `${baseLabel}. ${intl.formatMessage({ id: 'chat.unreadAnnouncement' }, { count })}`;
  }

  return count === null
    ? intl.formatMessage({ id: 'chat.title' })
    : intl.formatMessage({ id: 'chat.titleWithUnread' }, { count });
};

const ChatUnreadBadge = ({ unread }: ChatUnreadBadgeProps) => {
  const count = getVisibleChatUnreadCount(unread);
  if (count === null) return null;

  return (
    <Badge data-testid='chat-unread-badge' aria-hidden='true'>
      {count > 99 ? '99+' : count}
    </Badge>
  );
};

export const ChatUnreadLiveRegion = ({ unread }: ChatUnreadBadgeProps) => {
  const intl = useIntl();
  const count = getVisibleChatUnreadCount(unread);

  return (
    <LiveRegion aria-live='polite' aria-atomic='true' data-testid='chat-unread-live-region'>
      {count === null
        ? ''
        : intl.formatMessage({ id: 'chat.unreadAnnouncement' }, { count })}
    </LiveRegion>
  );
};

export default ChatUnreadBadge;
